import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { getAnimationDelay } from "./animations";

interface SpaceSummaryHeaderProps {
  formattedDateRange: string;
  sourceName: string;
}

export const SummaryHeaderV4 = ({
  formattedDateRange,
  sourceName,
}: SpaceSummaryHeaderProps) => (
  <div
    className="animate-fade-in-slow mb-2 opacity-0"
    style={{
      animationDelay: getAnimationDelay(0),
      animationFillMode: "forwards",
    }}
  >
    <Typography variant="body-sm" color="tertiary">
      {formattedDateRange} {t("ai_spaces_summaries.bullet")}{" "}
      {t("ai_spaces_summaries.summary_of")}
    </Typography>
    <div
      className="animate-fade-in-slow opacity-0"
      style={{
        animationDelay: getAnimationDelay(1),
        animationFillMode: "forwards",
      }}
    >
      <Typography variant="heading-lg">{sourceName}</Typography>
    </div>
  </div>
);
